import React from 'react'
import { LinkDataType } from './AddLink'
import { RootState, store } from '../../redux-stores/store'
import { Post } from '../../types/influencer/influencerTypes'
import { useSelector } from 'react-redux'
import { SocialPost } from '../../types/collaborations/CollaborationTypes'

interface LinkPreviewProps {
    link: LinkDataType,
    post: SocialPost | null
}
const LinkPreview:React.FC<LinkPreviewProps> = ({link, post}) => {

const influencer = useSelector((state: RootState) => state.influencer.influencer);

  return (
    <div className='card card-style preview-card m-0 shadow-none p-3'>
        <div className='d-flex justify-content-between align-items-end'>
            <div className='d-flex align-items-end me-3'>
                {
                    influencer?.profile_picture_url ? (
                    <img height={20} src={influencer?.profile_picture_url} alt='preview' className='rounded-4' />
                    ): (
                    <div className='rounded-4 profile-pic-placeholder' style={{height: '20px', width: '20px',}}>
                        <i className="fa fa-user rounded-4 p-1" style={{ border: '1px solid #ccc'}}></i>
                    </div>
                    )
                }
            </div>
            <div className="card card-style shadow-none w-100 m-0 pb-3 preview-msg">
                <img src={post?.thumbnail_url} className='preview-img' alt="preview" />
                <span className='mx-2  my-1'>Sent via Influns</span>
                <div className="d-flex justify-content-center align-items-center px-2">
                    <button className='btn-sm preview-btn mb-n1'>{link.button_text ? link.button_text : 'Enter Button Text'}</button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default LinkPreview